import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody, Button, Container } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import TableResolution1552 from './TableResolution1552';
import AnimatedBars from './AnimatedBars';
import Resolution1552Excel from './Resolution1552Excel';

const Resolution1552 = ({ thirdsList }) => {

    const [third, setThird] = useState(null);
    const [starterDate, setStarterDate] = React.useState(null);
    const [finalDate, setFinalDate] = React.useState(null);
    const [dataIndicator, setDataIndicator] = React.useState([]);

    useEffect(() => {

    }, []);

    const getIndicatorResolution1552 = async () => {
        if (starterDate != null && finalDate != null) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'indicadores/resolucion1552', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicio: moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final: moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                    id_tercero: third
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                setDataIndicator(data.indicador);
                console.log(data);
            }).catch(err => {
                setDataIndicator([]);
                console.log(err);
            });
        }
        else {
            alert("Ha ocurrido consultando este Indicador");
        }
    }

    const ExportResolution1552Excel = () => {
        Resolution1552Excel.exportExcel(dataIndicator);
    }

    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <div className="card__title">
                        <h5 className="bold-text">Resolución 1552</h5>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <TextField
                        id="select_third"
                        select
                        label="Tercero"
                        value={third}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            setThird(event.target.value);
                        }}

                        style={{ minWidth: '300px', maxWidth: '100%' }}
                    >
                        <MenuItem key={0} value={null}>
                            Ninguno
                        </MenuItem>
                        {
                            thirdsList.map((third, index) => {
                                return <MenuItem key={third.id_tercero} value={third.id_tercero}>{third.nombre}</MenuItem>
                            })
                        }
                    </TextField>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={starterDate}
                            onChange={(date) => {
                                setStarterDate(date);
                            }}
                            label="Fecha Inicial"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={finalDate}
                            onChange={(date) => {
                                setFinalDate(date);
                            }}
                            label="Fecha Final"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <Button
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary text-white"
                        onClick={() => {
                            getIndicatorResolution1552();
                        }}
                    >
                        Consultar
                    </Button>
                </Col>
                <br />
                {dataIndicator.length > 0 ? <Col md={12}>
                    <TableResolution1552 reactTableData={dataIndicator} />
                    <br />
                    <Button
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-success text-white"
                        onClick={() => {
                            ExportResolution1552Excel();
                        }}
                    >
                        Exportar a Excel
                    </Button>

                    <AnimatedBars dataIndicator={dataIndicator} />
                </Col> : null}
            </Row>
        </Fragment>
    );
}
export default Resolution1552;